import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BarChart3, Upload, History, LogOut, LogIn, Home } from 'lucide-react';

const Navbar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <nav className="bg-white shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="text-xl font-bold text-gray-800 flex items-center gap-2">
            <BarChart3 className="h-6 w-6 text-blue-600" />
            ChronoData
          </Link>
          
          <div className="flex items-center gap-6">
            {currentUser ? (
              <>
                <Link to="/" className="flex items-center gap-2 text-gray-600 hover:text-blue-600">
                  <Home className="h-5 w-5" />
                  <span>Accueil</span>
                </Link>
                <Link to="/upload" className="flex items-center gap-2 text-gray-600 hover:text-blue-600">
                  <Upload className="h-5 w-5" />
                  <span>Upload</span>
                </Link>
                <Link to="/compare" className="flex items-center gap-2 text-gray-600 hover:text-blue-600">
                  <BarChart3 className="h-5 w-5" />
                  <span>Compare</span>
                </Link>
                <Link to="/history" className="flex items-center gap-2 text-gray-600 hover:text-blue-600">
                  <History className="h-5 w-5" />
                  <span>History</span>
                </Link>
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 text-gray-600 hover:text-red-600"
                >
                  <LogOut className="h-5 w-5" />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <Link to="/login" className="flex items-center gap-2 text-gray-600 hover:text-blue-600">
                <LogIn className="h-5 w-5" />
                <span>Login</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
